module.exports = __webpack_public_path__ + "img/shopcart1.98715bff.jpg";